var map = {
	"./00.jpg": 2287,
	"./01.jpg": 2288,
	"./02.jpg": 2289,
	"./assets-foiling_00.jpg": 2290,
	"./assets-foiling_01.jpg": 2291,
	"./assets-foiling_02.jpg": 2292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2286;